import { render } from "./ClockRewindIcon.vue?vue&type=template&id=768502c1"
import script from "./ClockRewindIcon.vue?vue&type=script&lang=js"
export * from "./ClockRewindIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__